import { computed } from 'vue';

import { useNoOfProductsPerRow } from './useNoOfProductsPerRow';
import useConvoSearchExperiment from './useConvoSearchExperiment';
import { groupProductsByRow } from '../utils/groupProductsByRow';
import { ComputedRef, IBanner, InGridFiltersObj } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

/**
 *
 * @param {ComputedRef<IBanner[]>} rowsRef
 * @returns {ComputedRef<Array<IBanner | InGridFiltersObj >>}
 */
export default function useInGridFilters(rowsRef) {
  const inGridFilters = {
    inGridFilters: {},
    fullWidth: true,
    excludeRow: true,
  };

  const { convoSearchEnabled, rowIndex, hasFollowupQuestion } = useConvoSearchExperiment();

  const noOfProdsPerRowRef = useNoOfProductsPerRow();

  const getActualRowIndex = (rows, expectedRowIndex, noOfProdsPerRow) => {
    const sliceTo = (expectedRowIndex * noOfProdsPerRow) + 1;
    const excludeRowLength = rows
      .slice(0, sliceTo)
      .filter((row) => row.excludeRow).length;

    return expectedRowIndex + excludeRowLength;
  };

  const isPreviousRowExcluded = (groupedProducts, index) => {
    try {
      return groupedProducts[index - 1][0].excludeRow;
    } catch (e) {
      return false;
    }
  };

  return computed(() => {
    /* istanbul ignore else */
    if (!convoSearchEnabled.value || !hasFollowupQuestion.value) {
      return rowsRef.value;
    }

    const updatedRows = rowsRef.value;

    let actualRowIndex = getActualRowIndex(updatedRows, rowIndex.value, noOfProdsPerRowRef.value);
    const groupedProducts = groupProductsByRow(updatedRows, noOfProdsPerRowRef.value);
    /* istanbul ignore else */
    if (isPreviousRowExcluded(groupedProducts, actualRowIndex)) {
      actualRowIndex++;
    }

    const groupedRows = [
      ...groupedProducts.slice(0, actualRowIndex),
      inGridFilters,
      ...groupedProducts.slice(actualRowIndex),
    ];

    return groupedRows.flatMap((row) => row);
  });
}
